<template>
    <div class="list-icon">
        <h3 class="color_Azul family-01" v-if="(form.TipoTema == 'ACORDEON')" >{{form.Titulo}}</h3> 
        <hr v-show="(form.TipoTema == 'ACORDEON' && form.Titulo !='')" class="divider-02 hr-sm-left-0 bg-color"> 
        <h5 v-show="(form.TipoTema == 'ACORDEON' && form.Subtitulo !='')" class="color_Azul">{{form.Subtitulo}}</h5> 
        <div id="accordion" class="accordion" v-if="(form.TipoTema == 'ACORDEON')">
            <div v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                {{refreshLic}}
                <div  class="card-header header-testi collapsed" data-toggle="collapse" data-parent="#accordion" :href="'#collapse'+detalle.IdDetalleC">
                    <h6 class="color_Azul">
                        {{detalle.Nombre}}
                    </h6>
                </div>
                <div :id="'collapse'+detalle.IdDetalleC" class="collapse" data-parent="#accordion" >
                    <div class="card-body">
                        <div v-html="detalle.Descripcion" class="text-justify"></div>
                    </div>
                    <div v-if="detalle.Tipo == 'PDF'" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div style="width: 100%; overflow-y: hidden;"><iframe
                                :src="RutaFileA+detalle.Archivo"
                                width="100%" height="397"></iframe>
                        </div>
                        <div v-if="detalle.BtnEnlace == 'SI'" class="row justify-content-center mt-3">
                            <a download=""  :href="RutaFileA+detalle.Archivo"
                                target="_blank" class="button mb-3" tabindex="0">
                                <span :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></span>
                                &nbsp; {{detalle.NombreBtnEnlace}} &nbsp;
                                <span :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></span>
                            </a>
                        </div>
                    </div>

                    <div v-if="detalle.Tipo == 'PDFENLACE'" class="row justify-content-center mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" >
                            <div style="width: 100%; overflow-y: hidden;" class="mb-3">
                                <iframe :src="RutaFileA+detalle.Archivo" width="100%" height="397"></iframe>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="detalle.BtnEnlace == 'SI'">
                            <a :href="detalle.Enlace"
                                target="_blank" class="button mb-3" tabindex="0">
                                <span :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></span>
                                &nbsp; {{detalle.NombreBtnEnlace}} &nbsp;
                                <span :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></span>
                            </a>
                        </div>
                    </div>

                    <div v-if="detalle.Tipo == 'ENLACE'" class="row justify-content-center mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="detalle.BtnEnlace == 'SI'">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                    <a :href="detalle.Enlace"
                                        target="_blank" class="button mb-3" tabindex="0">
                                        <span :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></span>
                                        &nbsp; {{detalle.NombreBtnEnlace}} &nbsp;
                                        <span :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos'],
    data() {
        return {
            form:this.value,
            RutaFileA: '',
        }
    },methods: {
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },
    computed:{
        refreshLic: function(){
            this.RutaFileA = this.RutaFile;
        }
    }
}
</script>